import type { TFunction } from "i18next";

import type { ConfigActivityRow } from "@/api/config-server-stages";

/**
 * Configuração concluída, ou com a conversa do agente já iniciada, não volta para
 * pendente: no lugar do retorno, o duplo check (como a unidade cadastrada no CBC).
 */
export function activityDoneLabel(row: ConfigActivityRow, t: TFunction): string | undefined {
  if (row.status === "completed") return t("Completed");
  return row.executed ? t("Already executed") : undefined;
}
